import AutoformPage from './AutoformPage';

import useGlobalConstraintConfig from 'hooks/globalConstraints/useGlobalConstraintConfig';

const GlobalConstraints = () => {
    const config = useGlobalConstraintConfig();

    return <AutoformPage config={config} />;
};

export default GlobalConstraints;
